import { gql } from '@apollo/client';

export const READ_CUSTOMER_SUBSCRIPTIONS = gql`
  query ReadCustomerSubscriptions {
    readCustomerSubscriptions {
      id
      orderLineIdWithVersion
      renewal
      isRenewalDisabled
      scheduledTerminationDate
      orderStatus
      endDate
      orderLines {
        orderLineId
        pmcId
        version
        quantity
        billingFrequency
        billingType
        pmc {
          name
          prices {
            monthlyPrice
            validity {
              validFrom
              validTo
            }
          }
          description {
            en
            fi
            no
            sv
          }
        }
        salesOrderId
        charge {
          validity {
            validFrom
            validTo
          }
        }
        salesOrderStatus
      }
      creditCardId
      countryCode
      created
    }
  }
`;
